// Umami Cloud 연동 (2026-08-14, GA4에서 교체 - 원인 불명의 GA4 collect 미전송 문제로
// Umami Cloud 무료 Hobby 플랜으로 전환). REACT_APP_UMAMI_WEBSITE_ID가 없으면 완전히
// 비활성 - 스크립트를 로드하지 않고 모든 호출은 조용히 no-op.
const UMAMI_WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID;

let initialized = false;

type UmamiEventProps = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    umami?: {
      track: (
        eventNameOrPropsFn?: string | ((props: UmamiEventProps) => UmamiEventProps),
        eventData?: Record<string, string | number | null>,
      ) => void;
    };
  }
}

export function initAnalytics(): void {
  if (!UMAMI_WEBSITE_ID || initialized) return;
  initialized = true;

  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://cloud.umami.is/script.js';
  script.setAttribute('data-website-id', UMAMI_WEBSITE_ID);
  // SPA 라우트 전환은 usePageViewTracking()이 trackPageView()로 수동 전송하므로,
  // Umami 자체 자동 추적(최초 로드 + history 변경 감지)은 꺼서 중복 집계를 막는다.
  script.setAttribute('data-auto-track', 'false');
  document.head.appendChild(script);
}

/** feature/eventType은 recordFunnelEvent와 동일한 값을 그대로 Umami 커스텀 이벤트로 전달 */
export function trackEvent(eventName: string, params?: Record<string, string | number | null>): void {
  if (!UMAMI_WEBSITE_ID || !window.umami) return;
  window.umami.track(eventName, params ?? undefined);
}

/** SPA 라우트 전환 시 Umami에 수동으로 페이지뷰를 보낸다 (usePageViewTracking 전용). */
export function trackPageView(path: string): void {
  if (!UMAMI_WEBSITE_ID || !window.umami) return;
  const title = document.title;
  window.umami.track((props) => ({ ...props, url: path, title }));
}
